<template>
  <div>
    <md-dialog
      :md-active.sync="show"
      @md-opened="openDialog"
      @md-clicked-outside="closeDialog"
      @md-closed="closeDialog"
    >
      <md-dialog-title>Add new user</md-dialog-title>
      <div class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <form>
          <md-field
            class="md-layout-item md-small-size-100 md-size-100"
            :class="ApplicationIDClass"
            v-if="selectedApplicationId"
          >
            <label>Application name</label>
            <md-select
              v-model="applicationID"
              name="applicationID"
              id="applicationID"
              :disabled="selectedApplicationId != null"
            >
              <md-option v-for="application in applications" v-bind:key="application.pk" :value="application.pk">
                {{ application.name }}
              </md-option>
            </md-select>
            <span class="md-error">Application name is required</span>
          </md-field>

          <md-autocomplete
            v-model="applicationID"
            :md-options="applicationsOptions"
            @md-changed="applicationSelected"
            :class="ApplicationIDClass"
            v-else
          >
            <label>Application name</label>
            <template slot="md-autocomplete-item" slot-scope="{ item }">
              <md-highlight-text>{{ item }}</md-highlight-text>
            </template>

            <template slot="md-autocomplete-empty" slot-scope="{ term }">
              No Application name matching "{{ term }}" were found.
            </template>
            <span class="md-error">Application name is required</span>
          </md-autocomplete>

          <md-field class="md-layout-item md-small-size-100 md-size-100" :class="UsernameClass">
            <label>
              Username (optional)
            </label>
            <md-input v-model="username"></md-input>
            <span class="md-error">Username already exists</span>
          </md-field>
        </form>
        <div class="md-layout-item md-size-100 text-right">
          <md-button @click="closeDialog">Close</md-button>
          <md-button class="md-primary" @click="createNewAppUser">Add</md-button>
        </div>
      </div>
    </md-dialog>

    <md-dialog :md-active.sync="showUserCreated" class="warning-dialog">
      <md-dialog-title>
        User Created
      </md-dialog-title>
      <div class="md-dialog-content">
        <div class="md-subheading warning-text btm-padding">
          User created, you need to use enroll api to get an activation code.
        </div>
        User_id:
        <div class="user-id">
          <div class="key">
            <small class="holder">{{ userID }}</small>
          </div>
        </div>
        Username:
        <div class="user-id">
          <div class="key">
            <small class="holder">{{ username }}</small>
          </div>
        </div>
        <div dir="rtl">
          <md-button class="md-primary" @click="enrollUser">Enroll</md-button>
          <md-button @click="userDetails">Close</md-button>
        </div>
      </div>
    </md-dialog>
    <enroll-application-user
      :application_user_pk="applicationUserID"
      :show="showEnrollUser"
      @close="userDetails"
    ></enroll-application-user>
  </div>
</template>

<script>
import EnrollApplicationUser from "./EnrollApplicationUser";
import getApplication from "../api-manager/utils/applications";

export default {
  name: "CreateNewUser",
  components: { EnrollApplicationUser },
  props: ["show", "selectedApplicationId"],
  data() {
    return {
      applications: [],
      applicationID: null,
      username: "",
      userID: "",
      applicationUserID: "",
      hasApplicationIDClass: false,
      hasUsernameClass: false,
      showUserCreated: false,
      showEnrollUser: false
    };
  },
  computed: {
    ApplicationIDClass() {
      return {
        "md-invalid": this.hasApplicationIDClass
      };
    },
    UsernameClass() {
      return {
        "md-invalid": this.hasUsernameClass
      };
    },
    applicationsOptions() {
      return this.applications.map((x) => ({
        name: x.name,
        pk: x.pk,
        toLowerCase: () => x.name.toLowerCase(),
        toString: () => x.name,
      }));
    },
  },
  methods: {
    userDetails: function() {
      //    TODO maybe we need to redirect to application user details
      this.showUserCreated = false;
      this.showEnrollUser = false;
      this.closeDialog();
    },
    enrollUser: function() {
      this.showUserCreated = false;
      this.showEnrollUser = true;
    },
    createNewAppUser: async function() {
      if (this.applicationID === null) {
        this.hasApplicationIDClass = true;
        return;
      }
      let data = {
        application_pk: this.applicationID
      };
      if (this.username) {
        data.username = this.username;
      }
      const response = await this.$api.createUser({
        params: data
      });
      if (response.status === 400) {
        if (response.data.message_detail === "application_pk") {
          this.hasApplicationIDClass = true;
        } else if (response.data.message_detail === "username already exists"){
          this.hasUsernameClass = true;
        }
        return;
      }
      this.closeDialog();
      this.username = response.parsedData.username;
      this.userID = response.parsedData.user_id;
      this.applicationUserID = response.parsedData.application_user_pk;
      this.$router.push({ name: 'User Details', query: { user_pk: this.applicationUserID } });


      //TODO: show enroll user modal

      // this.showUserCreated = true;
    },
    closeDialog: function () {
      this.applicationID = null;
      this.hasUsernameClass = false;
      this.hasApplicationIDClass = false;
      this.$emit("close");
    },
    openDialog: function() {
      // this.applicationID = ''
      this.username = "";
    },
    copyApiKey: function() {
      let that = this;
      navigator.clipboard
        .writeText(this.apiKey)
        .then(function() {
          that.notifyVue("top", "right", "Successfully copied! ");
        })
        .catch(/* */);
    },
    notifyVue: function(verticalAlign, horizontalAlign, message) {
      this.$notify({
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "success"
      });
    },
    fetchApplications: async function() {
      this.applications = await getApplication({ page_size: 1000 });
    },
    applicationSelected(item) {
      this.applicationID = item.pk;
    },
  },

  mounted() {
    this.fetchApplications();
  },
  updated() {
    if (this.selectedApplicationId) {
      this.applicationID = this.selectedApplicationId;
    }
  }
};
</script>

<style scoped lang="scss">
.user-id {
  margin: 8px 0 16px 0;

  .btn {
    text-transform: none;
    margin-top: 8px;
    margin-left: 0;
    font-size: x-small;
    /*.md-ripple{*/
    /*    padding: 0px;*/
    /*}*/
    .md-icon {
      font-size: 16px !important;
    }
  }

  .holder {
    text-align: center;
    display: inline-block;
    width: 100%;
    padding: 8px 8px;
    border-style: solid;
    border-color: gray;
    border-width: 1px;
    background-color: gainsboro;
    border-radius: 4px;
    overflow-x: auto;
  }
}

.size-test {
  width: 100%;
}

.user-id .md-ripple {
  padding: 0 !important;
}

.btm-padding {
  padding-bottom: 32px;
}
</style>
